import { useTovQuery } from '@tov-plus/frontend-data';
import { PageEyebrow, PageLayout, TovButton, msg } from '@tov-plus/ui';
import { useParams } from '@tov-plus/frontend-data';
import { guestApi } from '../app/api';
import { StatePanel } from '../components/StatePanel';
import { guestQueryKeys } from '../lib/data/guestQueryKeys';

export function GallerySharePage() {
  const { shareToken } = useParams();
  const sharePackageQuery = useTovQuery({
    queryKey: shareToken
      ? guestQueryKeys.galleryShare(shareToken)
      : guestQueryKeys.galleryShare('pending'),
    queryFn: () => guestApi.getGallerySharePackage(shareToken!),
    enabled: Boolean(shareToken),
  });
  const sharePackage = sharePackageQuery.data ?? null;

  if (sharePackageQuery.isLoading) {
    return (
      <div className="guest-standalone">
        <StatePanel preset="loading" />
      </div>
    );
  }

  if (sharePackageQuery.isError || !sharePackage) {
    return (
      <div className="guest-standalone">
        <StatePanel preset="access-unavailable" />
      </div>
    );
  }

  return (
    <main className="guest-standalone">
      <PageLayout
        className="gallery-share-page"
        data-testid="gallery-share-page"
        title={msg('pages.gallery_share_page.shared_gallery')}
      >
        <section className="gallery-share-page__header">
          <PageEyebrow>
            {msg('pages.gallery_share_page.gallery_share_package')}
          </PageEyebrow>
          <p>
            {msg('pages.gallery_share_page.shared_gallery_download_message')}
          </p>
        </section>

        {sharePackage.items.length > 0 ? (
          <div className="gallery-share-page__grid">
            {sharePackage.items.map((item) => (
              <article
                key={item.gallery_item.id}
                className="gallery-share-page__item"
              >
                {item.display_url ? (
                  <img
                    alt={
                      item.gallery_item.caption ??
                      msg('pages.gallery_share_page.shared_gallery_item')
                    }
                    src={item.display_url}
                  />
                ) : (
                  <div className="gallery-share-page__fallback">
                    {msg('pages.gallery_share_page.shared_gallery_item')}
                  </div>
                )}
                <div className="gallery-share-page__item-footer">
                  <strong>
                    {item.gallery_item.caption ??
                      msg('pages.gallery_share_page.shared_gallery_item')}
                  </strong>
                  <TovButton asChild variant="secondary">
                    <a download href={item.download_url}>
                      {msg('pages.gallery_share_page.download_item')}
                    </a>
                  </TovButton>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <StatePanel preset="not-found" />
        )}
      </PageLayout>
    </main>
  );
}
